import 'lite-youtube-embed'
import 'lite-vimeo-embed/module/lite-vimeo-embed'
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import popover from '@alpinejs/ui/src/popover'
import dialog from '@alpinejs/ui/src/dialog'
import disclosure from '@alpinejs/ui/src/disclosure'

import 'virtual:svg-icons-register'
import.meta.glob('../img/**/*')

export function init() {
  window.APP = window.APP || {}
  window.Alpine = Alpine

  Alpine.plugin(dialog)
  Alpine.plugin(collapse)
  Alpine.plugin(disclosure)
  Alpine.plugin(popover)
  Alpine.plugin(focus)

  Alpine.start()
}

window.addEventListener('DOMContentLoaded', init)

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
